module.exports = __webpack_public_path__ + "img/39_40.d5d000f1.png";